import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Apply theme immediately to avoid flash. Honour an explicit saved choice;
// otherwise fall back to the device's OS-level colour-scheme preference.
try {
  const saved = localStorage.getItem('tt_theme');
  const systemDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  const theme = saved || (systemDark ? 'dark' : 'light');
  document.documentElement.setAttribute('data-theme', theme);
} catch {}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
